// Services.js - Enhanced with specific services
import { motion } from 'framer-motion';
import { FiCode, FiSmartphone, FiDatabase, FiShield, FiTrendingUp, FiBookOpen } from 'react-icons/fi';
import './Services.css';

const services = [
  {
    title: 'Full-Stack Web Development',
    description: 'End-to-end development of scalable web applications using PHP, MySQL, and modern JavaScript. From requirement analysis to deployment and maintenance, I deliver enterprise-grade solutions.',
    icon: FiCode,
    features: ['Custom Web Applications', 'Database Architecture', 'API Integration', 'Performance Optimization']
  },
  {
    title: 'Educational Technology Solutions',
    description: 'Specialized in building ed-tech platforms with features like content management, user authentication, search functionality, and analytics dashboards for educational institutions.',
    icon: FiBookOpen,
    features: ['Learning Management Systems', 'Exam Portals', 'Resource Libraries', 'Student Analytics']
  },
  {
    title: 'Database Design & Optimization',
    description: 'Expert in MySQL database architecture, query optimization, and performance tuning. Achieved 40% faster load times through strategic indexing and normalization.',
    icon: FiDatabase,
    features: ['Schema Design', 'Query Optimization', 'Data Migration', 'Performance Tuning']
  },
  {
    title: 'Responsive Web Applications',
    description: 'Creating responsive, mobile-first applications with Bootstrap and custom CSS that provide seamless experiences across all devices and screen sizes.',
    icon: FiSmartphone,
    features: ['Mobile-First Design', 'Cross-Browser Compatibility', 'Progressive Web Apps', 'Touch Interactions']
  },
  {
    title: 'Security Implementation',
    description: 'Implementing robust security measures including authentication, authorization, SQL injection prevention, and data validation to ensure application security.',
    icon: FiShield,
    features: ['User Authentication', 'Role-Based Access', 'Data Encryption', 'Security Audits']
  },
  {
    title: 'Tech Mentorship',
    description: 'Providing guidance and support for students and junior developers in web development, database design, and software engineering best practices.',
    icon: FiTrendingUp,
    features: ['Code Reviews', 'Career Guidance', 'Project Mentoring', 'Technical Training']
  }
];

function Services() {
  return (
    <section id="services" className="services section">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        Professional Services
      </motion.h2>
      
      <motion.p
        className="section-subtitle"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        Enterprise-grade development solutions with proven results
      </motion.p>

      <div className="services__grid">
        {services.map((service, i) => {
          const Icon = service.icon;
          return (
            <motion.article
              key={service.title}
              className="services__card glass"
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * i }}
              whileHover={{ y: -6 }}
            >
              <span className="services__icon">
                <Icon size={32} aria-hidden />
              </span>
              
              <h3 className="services__title">{service.title}</h3>
              
              <p className="services__desc">{service.description}</p>
              
              <div style={{ marginTop: '1rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {service.features.map((feature, idx) => (
                  <span 
                    key={idx}
                    style={{
                      fontSize: '0.75rem',
                      color: 'var(--accent)',
                      background: 'rgba(34, 211, 238, 0.1)',
                      padding: '0.2rem 0.6rem',
                      borderRadius: '12px',
                      border: '1px solid rgba(34, 211, 238, 0.2)'
                    }}
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
}

export default Services;